import type { IconProps } from './../../models/icon';

export function FacebookIcon({
  width = 24,
  height = 24,
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 22 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="M18.8312 1.5H2.25974C1.66042 1.5 1.08565 1.73705 0.661863 2.15901C0.238079 2.58097 0 3.15326 0 3.75L0 20.25C0 20.8467 0.238079 21.419 0.661863 21.841C1.08565 22.2629 1.66042 22.5 2.25974 22.5H8.72118V15.3605H5.75528V12H8.72118V9.43875C8.72118 6.52547 10.4631 4.91625 13.131 4.91625C14.4087 4.91625 15.7447 5.14313 15.7447 5.14313V8.0025H14.2726C12.8221 8.0025 12.3697 8.89875 12.3697 9.81797V12H15.6077L15.0899 15.3605H12.3697V22.5H18.8312C19.4305 22.5 20.0053 22.2629 20.429 21.841C20.8528 21.419 21.0909 20.8467 21.0909 20.25V3.75C21.0909 3.15326 20.8528 2.58097 20.429 2.15901C20.0053 1.73705 19.4305 1.5 18.8312 1.5Z"
        />
      </g>
    </svg>
  );
}
